import React from 'react';

import { ReactComponent as ArrowLeftIcon } from '../../assets/arrow-left.svg';

import { StyledColumnFillFields } from './styled';

const ReportContainerFillFields = () => {
  return (
    <StyledColumnFillFields>
      <ArrowLeftIcon width={80} height={88} />
      <span>Comece preenchendo os campos ao lado</span>
    </StyledColumnFillFields>
  );
};

export { ReportContainerFillFields };
